import type { ReactNode } from 'react';

import { PrimaryActionButton, StonePanel } from './primitives';

type StateKind = 'loading' | 'empty' | 'error' | 'offline';

interface StatePanelProps {
  kind: StateKind;
  title: string;
  children: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

export function StatePanel({ kind, title, children, actionLabel, onAction }: StatePanelProps) {
  return (
    <StonePanel
      aria-busy={kind === 'loading' || undefined}
      className="ar-state-panel"
      data-kind={kind}
    >
      <span aria-hidden="true" className="ar-state-panel__glyph">
        {kind === 'loading' ? '◌' : kind === 'error' ? '!' : kind === 'offline' ? '⌁' : '◇'}
      </span>
      <div>
        <h2>{title}</h2>
        <p>{children}</p>
      </div>
      {actionLabel && onAction && (
        <PrimaryActionButton onClick={onAction}>{actionLabel}</PrimaryActionButton>
      )}
    </StonePanel>
  );
}

export function LoadingState({ title = 'Preparing the realm' }: { title?: string }) {
  return (
    <StatePanel kind="loading" title={title}>
      Waterways, paths and discoveries are taking shape.
    </StatePanel>
  );
}

export function OfflineState() {
  return (
    <StatePanel kind="offline" title="Viewing your saved realm">
      You can look around while offline. Rewards and changes resume after reconnection.
    </StatePanel>
  );
}
